import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import MaterialBox from '../../../components/MaterialBox'
import MaterialTypography from '../../../components/MaterialTypography'
import { Grid } from '@mui/material'
import MaterialSelect from '../../../components/MaterialSelect'
import CountCard from './components/Cards/CountCard'
import ActiveTestRun from './components/Charts/ActiveTestRun'
import ClosedTestRun from './components/Charts/ClosedTestRun'
import ClosedTestBarChart from './components/Charts/ClosedTestBarChart'
import TestCaseTypeChart from './components/Charts/TestCaseTypeChart'
import { getProjectsMiddleware } from '../../../api/projectMiddleware'
import bfImage from '../../../assest/images/project_insights_image.png'
import { fetchData } from '../../Utils/Baseurl'

const SAMPLE_RESPONSE = {
  stats: [
    { name: "Total Test Case", count: 120, color: "#F8C7B9" },
    { name: "Total Test Plan", count: 15, color: "#F9E6AA" },
    { name: "Total Test Run", count: 80, color: "#A9D6D2" },
    { name: "Total Bugs", count: 35, color: "#AFD4F3" },
  ],
  active_test_run: {
    total: 8,
    passed: 1,
    untested: 3,
    failed: 1,
    retest: 1,
    skipped: 1,
    blocked: 1,
  },
  closed_test_run: [
    { date: "2025-01-02", count: 5 },
    { date: "2025-01-05", count: 3 },
    { date: "2025-01-12", count: 7 },
    { date: "2025-01-20", count: 2 },
    { date: "2025-02-01", count: 6 },
    { date: "2025-02-08", count: 4 },
    { date: "2025-02-15", count: 5 },
    { date: "2025-02-21", count: 3 },
    { date: "2025-03-03", count: 8 },
    { date: "2025-03-10", count: 6 },
    { date: "2025-03-18", count: 4 },
    { date: "2025-03-25", count: 7 },
    { date: "2025-04-02", count: 3 },
    { date: "2025-04-10", count: 5 },
    { date: "2025-04-15", count: 6 },
    { date: "2025-04-20", count: 4 },
    { date: "2025-05-05", count: 7 },
    { date: "2025-05-12", count: 8 },
    { date: "2025-05-18", count: 5 },
    { date: "2025-05-25", count: 6 },
  ],
  closed_test_bar_chart: {
    categories: [
      "Oct 21", "Oct 22", "Oct 23", "Oct 24", "Oct 25", "Oct 26", "Oct 27",
      "Oct 28", "Oct 29", "Oct 30", "Oct 31", "Nov 1", "Nov 3", "Nov 4",
      "Nov 5", "Nov 6", "Nov 7", "Nov 8", "Nov 9", "Nov 10",
    ],
    series: [
      {
        name: "Passed",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Skipped",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  },
  test_case_type_chart: {
    categories: [
      "Functional", "Non-functional", "Performance", "Acceptance",
      "Accessibility", "Compatibility", "Destructive", "Security",
      "Regression", "Smoke", "Sanity", "Usability",
    ],
    chartSeries: [10, 6, 8, 5, 4, 7, 3, 9, 11, 6, 8, 5],
  },
};

const ProjectInsights = () => {
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [insightsData, setInsightsData] = useState(null);

  const fetchProjectList = async () => {
    try {
      const user_id = sessionStorage.getItem("currentUser");
      const response = await getProjectsMiddleware(user_id);
      setProjectList(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProjectList();
  }, []);

  useEffect(() => {
    const fetchProjectInsights = async () => {
      try {
        const response = await fetchData(
          `api/project_insights/?project_id=${selectedProject}`
        );
        setInsightsData(response.data); 
        console.log(response, "Response");
      } catch (error) {
        console.error(error);
      }
    };

    if (selectedProject) {
      fetchProjectInsights();
    }
  }, [selectedProject]);

  const handleProjectChange = (selectedOption) => {
    setSelectedProject(selectedOption.value);
  };

  return (
    <DashboardLayout>
      <Grid container direction="row" spacing={1} px={0.5}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <MaterialBox
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
            }}
          >
            <MaterialTypography varinat="h5" color="dark" fontWeight="bold">
              Project Insights
            </MaterialTypography>
            <MaterialTypography variant="caption" color="secondary">
              Detailed analytics and reports on project testing activities,
              including test coverage, defect trends, and team performance
              metrics.
            </MaterialTypography>
          </MaterialBox>
        </Grid>
        <Grid
          size={{ xs: 12, sm: 6 }}
          sx={{ display: "flex", flexDirection: "column", gap: 0.5, paddingX: 2 }}
        >
          <MaterialTypography variant="caption" color="dark" fontWeight="bold">
            Project
          </MaterialTypography>
          <MaterialSelect
            label="Select Project"
            size="small"
            options={projectList.map((item) => ({
              value: item.project_id,
              label: item.project_name,
            }))}
            fullWidth
            sx={{ maxWidth: 100 }}
            onChange={handleProjectChange}
          />
        </Grid>
      </Grid>

      {!selectedProject ? (
        <MaterialBox
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <img src={bfImage} alt="Project Insights" width="500px" />
        </MaterialBox>
      ) : (
        <>
          <Grid container direction="row" spacing={2} mt={1} px={1}>
            {insightsData?.stats?.map((item, index) => (
              <Grid size={{ xs: 6, sm: 6, md: 3 }} key={index}>
                <CountCard
                  name={item.name}
                  count={item.count}
                  color={item.color}
                />
              </Grid>
            ))}
          </Grid>
          <Grid container direction="row" spacing={2} mt={2} px={1}>
            <Grid size={{ xs: 12, md: 6 }}>
              <ActiveTestRun {...insightsData?.active_test_run} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <ClosedTestRun chartData={insightsData?.closed_test_run} />
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              <ClosedTestBarChart
                categories={insightsData?.closed_test_bar_chart?.categories}
                series={insightsData?.closed_test_bar_chart?.series}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              <TestCaseTypeChart
                categories={insightsData?.test_case_type_chart?.categories}
                chartSeries={insightsData?.test_case_type_chart?.chartSeries}
              />
            </Grid>
          </Grid>
        </>
      )}
    </DashboardLayout>
  );
};

export default ProjectInsights
